const steps = [
  {
    key: "name",
    label: "Назва проєкту",
    placeholder: "Яка назва вашого проєкту?",
    questions: `
Подумайте, яку проблему вирішує проєкт або що він змінює.
Що саме ви хочете покращити чи змінити?
Кому буде корисний цей проєкт?
Які головні ідеї чи цінності він несе?
Приклад: якщо проєкт спрямований на покращення шкільного подвір’я, назва може бути: "Затишне шкільне подвір’я".`,
  },
  {
    key: "problem",
    label: "1. Проблема (Problem)",
    placeholder:
      "Подумайте, яку соціальну проблему ви хочете вирішити. Це може бути щось, що вас хвилює: наприклад, забруднення довкілля, допомога бездомним тваринам, або нестача спортивних майданчиків. Запишіть 1-3 проблеми. ",
    questions: `
- Що вас найбільше турбує у вашому місті, школі чи серед друзів?
- Чому ця проблема важлива?
- Чи знаєте ви інших людей, які також стикаються з цією проблемою?`,
  },
  {
    key: "customer_segments",
    label: "2. Сегменти клієнтів (Customer Segments)",
    placeholder: `Визначте, кому потрібне ваше рішення. Це можуть бути певні люди, групи чи навіть тварини.
  Подумайте про тих, хто потребує допомоги.`,
    questions: `- Хто страждає від цієї проблеми?
  - Хто може отримати користь від вашої ідеї?
  - Наприклад: це учні вашої школи, мешканці району, бездомні тварини чи люди похилого віку?`,
  },
  {
    key: "unique_value_proposition",
    label: "3. Унікальна ціннісна пропозиція (Unique Value Proposition)",
    placeholder: `Напишіть одне речення, яке пояснює, чому ваша ідея важлива і чим вона особлива.
  Це коротке гасло вашого проєкту.`,
    questions: `- Як ваша ідея може змінити ситуацію на краще?
  - Чим ваше рішення відрізняється від інших способів вирішення проблеми?
  - Наприклад: "Ми створимо чисті парки, щоб люди могли відпочивати в затишку і безпеці."`,
  },
  {
    key: "solution",
    label: "4. Рішення (Solution)",
    placeholder:
      "Опишіть, як саме ви будете вирішувати проблему. Це може бути конкретний план або дії.",
    questions: `- Що ви будете робити, щоб допомогти?
    - Чи це буде акція, платформа, збір коштів, чи інший вид діяльності?
    - Наприклад: "Ми організуємо команду для збору сміття у парку щосуботи."`,
  },
  {
    key: "channels",
    label: "5. Канали (Channels)",
    placeholder: `Подумайте, як ви розкажете про свою ідею іншим людям і залучите їх.
    Це можуть бути соціальні мережі, шкільні оголошення, листівки чи навіть презентації у класі.`,
    questions: `- Як люди дізнаються про ваш проєкт?
    - Хто може допомогти вам розповсюдити інформацію?`,
  },
  {
    key: "cost_structure",
    label: "6. Структура витрат (Cost Structure)",
    placeholder: `Вкажіть, на що вам потрібно буде витратити гроші або ресурси.
    Наприклад, матеріали для акцій, реклама, інструменти чи транспорт.`,
    questions: `- Що вам потрібно, щоб реалізувати ідею?
    - Чи можна щось отримати безкоштовно або попросити допомоги?`,
  },
  {
    key: "revenue_streams",
    label: "7. Джерела доходів (Revenue Streams)",
    placeholder: `Напишіть, звідки ви будете брати гроші для вашого проєкту.
    Це можуть бути донати, підтримка місцевого бізнесу, гранти або навіть збір коштів через ярмарки.`,
    questions: `- Як ви зможете знайти гроші чи ресурси?
    - Чи знаєте ви людей або організації, які можуть допомогти?`,
  },
  {
    key: "key_metrics",
    label: "8. Ключові показники ефективності (Key Metrics)",
    placeholder: `Подумайте, як ви будете визначати, чи ваш проєкт успішний.
    Це можуть бути конкретні цифри або події: наприклад, кількість зібраного сміття чи залучених людей.`,
    questions: `- Як дізнатися, що ваш проєкт спрацював?
    - Що є показником успіху?`,
  },
  {
    key: "unfair_advantage",
    label: "9. Несправедливі переваги (Unfair Advantage)",
    placeholder: `Вкажіть, що саме робить ваш проєкт унікальним і таким, якого важко скопіювати.
    Це може бути ваш ентузіазм, підтримка громади чи унікальна ідея.`,
    questions: `- Що у вас є такого, чого немає в інших?
    - Чому саме ви зможете це зробити?`,
  },
];

export default steps;
